/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { cloneElement, isValidElement } from 'react';

import Icon from '../components/icon';

/**
 * Creates an Icon component, either by using an MUI component or our existing Icon component.
 * @param {Object} params - Parameters for creating the icon component.
 * @param {React.Element|string} params.icon - The icon element or icon name.
 * @param {number} params.size - The size of the icon.
 * @param {Object} params.props - Additional properties to pass to the icon.
 * @returns {React.Element} - The Icon component.
 */

export default ({ icon, size, ...props }) => {
  if (isValidElement(icon)) {
    let sx = {};

    if (icon.props.sx) {
      sx = icon.props.sx;
    } else if (size) {
      sx = { height: size, width: size };
    }

    return cloneElement(icon, { sx, ...props });
  }

  return <Icon icon={icon} size={size} {...props} />;
};
